import toArray from "lodash/toArray";
import moment from "moment";

import { formatStructuredText } from "../Utils";

export function buildAuthor({
    avatarSrc = undefined,
    id,
    isCertified = false,
    isChatbot = false,
    isElite = false,
    isOfficial = false,
    isOriginalPoster = false,
    lastActiveDate = moment().toISOString(),
    name,
    reputation = undefined,
    uuid,
}) {
    return {
        avatarSrc,
        id,
        isCertified,
        isChatbot,
        isElite,
        isOfficial,
        isOriginalPoster,
        lastActiveDate,
        name,
        reputation,
        uuid,
    };
}

export function buildMessage({
    actions = [],
    author,
    customerRepliedToMarkAsResolved = undefined,
    dateCreated = moment().toISOString(),
    id,
    uuid,
    isFirstResponseMessage = false,
    isLoading = false,
    lastUpdated = moment().toISOString(),
    messageText = undefined,
    messageTextHtml = undefined,
    resolved = undefined,
    responseId,
    type,
    viewedByUser,
}) {
    return {
        actions: toArray(actions),
        author,
        customerRepliedToMarkAsResolved,
        dateCreated,
        id,
        uuid,
        isFirstResponseMessage,
        isLoading,
        lastUpdated,
        messageText: formatStructuredText(messageText),
        rawMessageText: messageText,
        messageTextHtml,
        resolved,
        responseId,
        type,
        viewedByUser,
    };
}

export function buildQuestion({
    author,
    body,
    closeQuestionWhenEscalated = false,
    company,
    confirmAccepts = false,
    dateClosed = undefined,
    dateCreated = moment().toISOString(),
    hasOfficialMessages,
    id,
    isAnswered,
    isInteractionAllowed = true,
    lastUpdated = moment().toISOString(),
    reroutingStatus,
    status,
    subject,
    type,
    uuid,
    unreadMessageCount,
    chatTranscriptAsJson,
    isLastMessageMarkedAsResolvedBy,
}) {
    return {
        author: buildAuthor(author),
        body: formatStructuredText(body),
        closeQuestionWhenEscalated,
        company,
        confirmAccepts,
        dateClosed,
        dateCreated,
        hasOfficialMessages,
        id,
        isAnswered,
        isInteractionAllowed,
        lastUpdated,
        rawBody: body,
        reroutingStatus,
        status,
        subject,
        type,
        uuid,
        unreadMessageCount,
        chatTranscriptAsJson,
        isLastMessageMarkedAsResolvedBy,
    };
}

export function buildResponse({
    author,
    responseMessageAuthor,
    body,
    customerHappiness = "NOT_RATED",
    dateCreated = moment().toISOString(),
    happiness = "not-rated",
    happinessLastUpdated = undefined,
    id,
    uuid,
    isAccepted = false,
    isLeavingRating = false,
    isLeavingTestimonial = false,
    isViewedByUser,
    lastUpdated = moment().toISOString(),
    messages = [],
    quickReply = undefined,
    ratingInProgress = false,
    recognitionRecipient,
    showChatbotNameAndAvatar = true,
    testimonialDateCreated = undefined,
    clusterId = undefined,
}) {
    return {
        author: buildAuthor(author),
        responseMessageAuthor: responseMessageAuthor ? buildAuthor(responseMessageAuthor) : undefined,
        body,
        customerHappiness,
        dateCreated,
        happiness,
        happinessLastUpdated,
        id,
        uuid,
        isAccepted,
        isLeavingRating,
        isLeavingTestimonial,
        isViewedByUser,
        lastUpdated,
        messages,
        quickReply,
        ratingInProgress,
        recognitionRecipient: buildAuthor(recognitionRecipient),
        showChatbotNameAndAvatar,
        testimonialDateCreated,
        clusterId,
    };
}
